import { render, staticRenderFns } from "./public-header.component.html?vue&type=template&id=626bd81c&"
import script from "./public-header.component.ts?vue&type=script&lang=ts&"
export * from "./public-header.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports